module.exports = {"130771001":"南站街道","130771002":"马路东街道","130771100":"老鸦庄镇","130771101":"沈家屯镇","130771102":"姚家房镇","130771103":"沙岭子镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130771.json
// module id = 197
// module chunks = 0